import React from "react";

import ProfileShell from "./ProfileShell";
import SingleImage from "../../components/profile/SingleImage";

// Route: /images/:uid  →  a single post/image view.
// SingleImage uses the already-selected image from context when navigated to
// in-app, and otherwise fetches it from the :uid in the URL (direct link/share).
export default function ImagePage() {
  return (
    <ProfileShell>
      <SingleImage />
    </ProfileShell>
  );
}
